/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the melting temperature (Tm) of a DNA oligo using nearest-neighbor thermodynamics.`)
};

const es_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la temperatura de fusión (Tm) de un oligo de ADN usando termodinámica de vecino más cercano.`)
};

const de_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie die Schmelztemperatur (Tm) eines DNA-Oligos mit Nearest-Neighbor-Thermodynamik.`)
};

const nl_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de smelttemperatuur (Tm) van een DNA-oligo met nearest-neighbor-thermodynamica.`)
};

const fr_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la température de fusion (Tm) d'un oligo d'ADN à l'aide de la thermodynamique des plus proches voisins.`)
};

const it_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la temperatura di fusione (Tm) di un oligo di DNA usando la termodinamica dei vicini più prossimi.`)
};

const pt_br2_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a temperatura de fusão (Tm) de um oligo de DNA usando termodinâmica do vizinho mais próximo.`)
};

const pt_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a temperatura de fusão (Tm) de um oligonucleótido de ADN usando a termodinâmica do vizinho mais próximo.`)
};

const ja_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近接塩基対法（nearest-neighbor法）を使ってDNAオリゴの融解温度 (Tm) を計算します。`)
};

const zh_tm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用最近邻热力学方法计算 DNA 寡核苷酸的解链温度（Tm）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_tool_description", locale)
	if (locale === "en") return en_tm_tool_description(inputs)
	if (locale === "es") return es_tm_tool_description(inputs)
	if (locale === "de") return de_tm_tool_description(inputs)
	if (locale === "nl") return nl_tm_tool_description(inputs)
	if (locale === "fr") return fr_tm_tool_description(inputs)
	if (locale === "it") return it_tm_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_tm_tool_description(inputs)
	if (locale === "pt") return pt_tm_tool_description(inputs)
	if (locale === "ja") return ja_tm_tool_description(inputs)
	return zh_tm_tool_description(inputs)
};